import { Chip, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import moment from "moment";
import React from "react";
import ChangeCircleRoundedIcon from '@mui/icons-material/ChangeCircleRounded';
import EventRepeatRoundedIcon from '@mui/icons-material/EventRepeatRounded';
import RoomPreferencesRoundedIcon from '@mui/icons-material/RoomPreferencesRounded';
import './requestListItem.scss'

const RequestListItem: React.FC<any> = ({ request }) => {
    const switchStatus = (status: string) => {
        switch (status) {
            case '0':
                return <Chip label="Pending" className="chipsPending" size="small" />
            case '1':
                return <Chip label="Approved" className="chipsSuccess" size="small" />
            case '2':
                return <Chip label="Rejected" className="chipsRejected" size="small" />
            default:
                return <Chip label="Chip Filled" className="chipsPending" size="small" />
        }
    }

    const RequestType = () => {
        switch (request.requestCode) {
            case 'LR':
                return <>
                    <ListItem
                        key={request._id}
                        className="mob-Width"
                    >
                        <ListItemIcon>
                            <ChangeCircleRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <span className="flex font-weight-700 justify-content-between m-0">
                                    Leave
                                    {switchStatus(request.Status)}
                                </span>}
                            secondary={
                                <>
                                    <>
                                        <span style={{
                                            fontSize: "12px",
                                            color: "#717684 !important",
                                            marginRight: "10px"
                                        }}>From: {moment(new Date(request.details.leaveFrom)).format('MMM D, YYYY')}</span>
                                        <span style={{
                                            fontSize: "12px",
                                            color: "#717684 !important"
                                        }}>To: {moment(new Date(request.details.leaveTo)).format('MMM D, YYYY')}</span>
                                    </>
                                </>
                            }
                        />
                    </ListItem>
                </>
            case 'DR':
                return <>
                    <ListItem
                        key={request._id}

                    >
                        <ListItemIcon>
                            <EventRepeatRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary={<span className="flex font-weight-700 justify-content-between m-0">
                                Date Change
                                {switchStatus(request.Status)}
                            </span>}
                            secondary={
                                <>
                                    <span style={{
                                        fontSize: "12px",
                                        color: "#717684 !important",
                                        marginRight: "10px"
                                    }}>New Placement Start Date: {moment(new Date(request.details.newPlacementStart)).format('MMM d, YYYY')}</span>
                                    <span style={{
                                        fontSize: "12px",
                                        color: "#717684 !important"
                                    }}>New Placement End Date: {moment(new Date(request.details.newPlacementEnd)).format('MMM d, YYYY')}</span>
                                </>
                            }
                        />
                    </ListItem>
                </>
            case 'CP':
                return <>
                    <ListItem
                        key={request._id}

                    >
                        <ListItemIcon>
                            <RoomPreferencesRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            primary={<span className="flex font-weight-700 justify-content-between m-0">
                                Placement Change
                                {switchStatus(request.Status)}
                            </span>}
                            secondary={
                                <>
                                    <span style={{
                                        fontSize: "12px",
                                        color: "#717684 !important",
                                        marginRight: "10px"
                                    }}>New Placement Company: {request.details.newCompany}</span>
                                    <span style={{
                                        fontSize: "12px",
                                        color: "#717684 !important"
                                    }}>New Placement Job Role: {request.details.newJobRole}</span>
                                </>
                            }
                        />
                    </ListItem>
                </>
            default: <>
            </>
        }

    }

    return (
        <>
            {
                RequestType()
            }
        </>
    )


}
export default RequestListItem